export default __webpack_public_path__ + "static/inauguration-institut-ca27dedf006f02a516e4afeae242cf00.png";